import { getToken, getAuthUrl } from '@accor/customer-api/cloud'
import { logger } from '@/services/logger'

export const getTokenErrorHandler = async () => {
  try {
    const { token } = await getToken()

    return token
  } catch (err) {
    logger.error(`${err}`)
    // Disable redirection if localeStorage is present
    if (!localStorage.getItem('ahclient-no-auth-redirect')) {
      window.location.href = getAuthUrl()
      throw new Error(
        `getTokenErrorHandler - Customer-account: User Authentication is required : ${err}`
      )
    }
  }
}
